import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const purchaseLoadFileCreateAtom = createMutationAtomFactory(
  'trade.purchaseLoadFileCreate',
  (params: {
    purchaseLoadId: string;
    fileName: string;
    fileSize: number;
    mimeType: string;
  }) => ({
    tradePurchaseLoadFileCreate: {
      __args: {
        id: params.purchaseLoadId,
        input: {
          fileName: params.fileName,
          fileSize: params.fileSize,
          mimeType: params.mimeType,
          public: false,
        },
      },
      file: {
        id: true,
        fileName: true,
        status: true,
      },
      uploadUrl: true,
    },
  }),
  { showLoadingOverlay: false },
);
